import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-fluid px-0"
}
const _hoisted_3 = { class: "card card-one" }
const _hoisted_4 = { class: "card-header px-5 py-4 border-0" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = {
  class: "d-flex justify-content-end",
  "data-kt-user-table-toolbar": "base"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "las la-sync fs-1 text-primary" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { style: {"margin-right":"5px !important"} }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_16 = { class: "d-md-flex d-block" }
const _hoisted_17 = { class: "w-100 mb-3" }
const _hoisted_18 = {
  key: 0,
  id: "demo",
  class: "w-100 w-md-50 w-lg-25 ms-md-5 collapse no-transition"
}
const _hoisted_19 = { class: "w-100 list-boxes p-5 border-dashed border-1 border-primary rounded" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "border-bottom mb-2 pb-3 text-gray-800" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers fs-2x text-primary" })
  ])
], -1)
const _hoisted_23 = {
  class: "scroll-y me-n5 pe-3 dual-list list-left col-sm-12 px-0 mh-600px",
  id: "kt_explore_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#vz_detail_drawer__body",
  "data-kt-scroll-dependencies": "#vz_detail_drawer__header",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_24 = { class: "well text-right" }
const _hoisted_25 = { class: "list-group border-0" }
const _hoisted_26 = { class: "d-flex align-items-center position-relative m-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { id: "draggable-events" }
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "d-flex align-items-center bg-light-info rounded p-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers fs-2x me-3 text-primary" }, null, -1)
const _hoisted_34 = { class: "flex-grow-1 me-2" }
const _hoisted_35 = ["id"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted d-block" }, null, -1)
const _hoisted_37 = { class: "list-arrows" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye fs-6" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "engage-toolbar d-flex position-fixed px-5 fw-bolder zindex-2 top-50 end-0 transform-90 mt-20 gap-2" }
const _hoisted_42 = {
  href: "#demo",
  class: "engage-demos-toggle btn btn-flex h-35px bg-body btn-color-gray-700 btn-active-color-gray-900 shadow fs-6 px-4 rounded-top-0",
  "data-bs-toggle": "collapse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vz_filter = _resolveComponent("vz-filter")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_vz_add_schedule = _resolveComponent("vz-add-schedule")!
  const _component_FormDetailModal = _resolveComponent("FormDetailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh())),
                  class: "svg-icon svg-icon-1 position-absolute ms-3"
                }, _hoisted_8),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  onKeyup: _cache[1] || (_cache[1] = 
                  () => {
                    if (
                      _ctx.searchTermEvent.length == 0 ||
                      _ctx.searchTermEvent.length >= 3
                    ) {
                      _ctx.refresh();
                    }
                  }
                ),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTermEvent) = $event)),
                  "data-kt-user-table-filter": "search",
                  class: "form-control w-md-350px ps-13",
                  placeholder: _ctx.t('common.search')
                }, null, 40, _hoisted_9), [
                  [_vModelText, _ctx.searchTermEvent]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
                  type: "button",
                  class: "btn bg-transparent position-relative pe-0"
                }, _hoisted_13),
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_vz_filter, {
                    options: _ctx.scheduleFilter,
                    defaultFilter: {},
                    viewName: "scheduleFilter",
                    onFilterChange: _ctx.applyFilter
                  }, null, 8, ["options", "onFilterChange"])
                ]),
                (_ctx.hasPermission('VYZOR:APPLICATIONS:SCHEDULER:CREATE'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-outline btn-outline-primary btn-active-light-primary ms-3",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
                    }, [
                      _hoisted_15,
                      _createTextVNode(_toDisplayString(_ctx.t("common.addTask")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["card-body pt-2 px-5", [_ctx.loading && 'overlay overlay-block']])
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FullCalendar, {
                  class: "min-h-500px",
                  ref: "calendarRef",
                  options: _ctx.calendarOptions
                }, null, 8, ["options"])
              ]),
              (_ctx.hasPermission('VYZOR:APPLICATIONS:SCHEDULER:CREATE'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("h3", _hoisted_21, [
                          _hoisted_22,
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.forms")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("ul", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("span", {
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchData())),
                                  class: "svg-icon svg-icon-1 position-absolute ms-3 hand-cursor"
                                }, _hoisted_28),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  onKeyup: _cache[6] || (_cache[6] = 
                              () => {
                                if (
                                  _ctx.searchTerm.length == 0 ||
                                  _ctx.searchTerm.length >= 3
                                ) {
                                  _ctx.searchData();
                                }
                              }
                            ),
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchTerm) = $event)),
                                  "data-kt-user-table-filter": "search",
                                  class: "form-control ps-13 mb-2 mb-sm-0",
                                  placeholder: _ctx.t('common.search')
                                }, null, 40, _hoisted_29), [
                                  [_vModelText, _ctx.searchTerm]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: i,
                                    class: "list-group-item drop-event",
                                    id: form.webId
                                  }, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _hoisted_33,
                                      _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("span", {
                                          id: form.webId,
                                          ref_for: true,
                                          ref: 'form_' + form.webId,
                                          class: "fw-bolder text-gray-800 text-hover-primary fs-6"
                                        }, _toDisplayString(form.name), 9, _hoisted_35),
                                        _hoisted_36
                                      ]),
                                      _createElementVNode("span", _hoisted_37, [
                                        _createElementVNode("a", {
                                          class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                                          onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(form.webId)), ["stop"])
                                        }, _hoisted_40, 8, _hoisted_38)
                                      ])
                                    ])
                                  ], 8, _hoisted_31))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        _createVNode(_component_vz_add_schedule, {
          onSubmit: _ctx.submitData,
          data: _ctx.editData,
          isEditable: _ctx.isEditable,
          onUpdate: _ctx.updateData,
          onTaskDelete: _ctx.deleteTask,
          modelValue: _ctx.show,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.show) = $event))
        }, null, 8, ["onSubmit", "data", "isEditable", "onUpdate", "onTaskDelete", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("a", _hoisted_42, _toDisplayString(_ctx.t("common.forms")), 1)
      ])
    ]),
    _createVNode(_component_FormDetailModal, {
      viewName: "form_detail_modal",
      data: _ctx.selectedForm,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "showDialog"])
  ], 64))
}